<app-badge
  *ngIf="diff !== undefined"
  [label]="label"
  [icon]="icon"
  [color]="color"
  [textColor]="textColor"
  [variant]="variant"
></app-badge>
